//tasks-day-soak-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { SoakTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";

interface TasksDaySoakSectionProps {
  rows: SoakTaskRow[];
  soakColumns: any;
  soakColumnOptions: any;
  periodTasksTag?: number;
  periodTasks: Tasks[]; // <-- received via props
  title: string;
}

export default function TasksDaySoakSection({
  rows,
  soakColumns,
  soakColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDaySoakSectionProps) {
  // EXACT calculation used previously in TasksPage
  const trayTotal = periodTasks[0].soak.reduce((sum, t) => sum + t.trays, 0);

  return (
    <Box>
      {/* ----- HEADER (copied exactly from TasksPage) ----- */}
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}
        {rows.length > 0 && (
          <Typography sx={{ float: "right" }} color="black" variant="body1">
            <strong>Trays to Soak Total: {trayTotal}</strong>
          </Typography>
        )}
      </Typography>

      {/* ----- GRID ----- */}
      <TaskGrid
        key={periodTasksTag}
        taskKey="soak"
        rows={rows}
        baseColumns={soakColumns}
        columnOptions={soakColumnOptions}
        rowClassName={(params) => {
          const batch = params.row.batchNumber;
          return batch ? `batch-${batch.replace(/[^a-zA-Z0-9]/g, "_")}` : "";
        }}
      />
    </Box>
  );
}
